/* unplugin-vue-components disabled */import { render } from "./base-confirm-dialog.vue?vue&type=template&id=852f0da6"
import script from "./base-confirm-dialog.vue?vue&type=script&lang=js"
export * from "./base-confirm-dialog.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/amoeba-logistics-information-system-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__